// Container hierarchy under the camera-transformed `world`. Draw order:
// fills (bottom) -> borders -> overlay (top), so borders sit above ownership
// fills and the selection glow sits above everything.

import { Container } from 'pixi.js';

export interface Layers {
  world: Container; // camera transform applied here
  fills: Container; // per-country ownership fills (recolorable)
  borders: Container; // boundary mesh
  overlay: Container; // selection glow; future war arrows / occupation bars
}

export function createLayers(): Layers {
  const world = new Container();
  const fills = new Container();
  const borders = new Container();
  const overlay = new Container();
  world.addChild(fills, borders, overlay);
  return { world, fills, borders, overlay };
}
